import "./Error.css";

export default function Error() {
  return <div className="App-error">Error</div>;
}
